// extracted by mini-css-extract-plugin
module.exports = {"answerContainer":"add-text-answer-button_answerContainer__1Xgv7","containerAddAnswerText":"add-text-answer-button_containerAddAnswerText__3wU-t"};